<template>
  <div>
    <a-form-model :model="countData" :rules="rules" ref="ruleForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <div class="flex_">
          <p class="p-header">标的信息</p>
          <!-- 装修及家具（元） -->
          <div class="form_item">
            <a-form-model-item :prop="!disabledAll?'ZXJJ':''" :label-col="{ span: 12 }" label="装修及家具（元）">
              <a-input :disabled="disabledAll" style="width: 280px" v-model="countData.ZXJJ"
                @change="(e) => changeData(e.target.value, 'ZXJJ')" placeholder="请输入装修及家具金额"></a-input>
            </a-form-model-item>
          </div>
          <div class="form_item">
            <a-form-model-item :prop="!disabledAll?'JQSB':''" :label-col="{ span: 12 }" label="机器设备（元）">
              <a-input :disabled="disabledAll" style="width: 280px" v-model="countData.JQSB"
                @change="(e) => changeData(e.target.value, 'JQSB')" placeholder="请输入机器设备金额"></a-input>
            </a-form-model-item>
          </div>
          <div class="form_item">
            <a-form-model-item :prop="!disabledAll?'CHJE':''" :label-col="{ span: 12 }" label="存货（元）">
              <a-input :disabled="disabledAll" style="width: 280px" v-model="countData.CHJE"
                @change="(e) => changeData(e.target.value, 'CHJE')" placeholder="请输入存货金额"></a-input>
            </a-form-model-item>
          </div>
          <!-- <p class='p-header'>加费扩展条款</p> -->
          <!-- 附加盗抢责任 -->
          <div class="form_item">
            <a-form-model-item :label-col="{ span: 12 }" label="附加盗抢责任">
              <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.DQZR" @change="(value) => changeData(value, 'DQZR')">
                <a-select-option v-for="(item, index) in DQZROptions" :key="item.value + 'DQZR' + index"
                  :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <p class='p-header'>免费扩展条款</p>
          <p>
            1.水箱、水管爆裂扩展条款<br>
            2.罢工、暴乱及民众骚乱扩展条款<br>
            3.恶意破坏扩展条款<br>
            4.自动喷淋系统水损扩展条款<br>
            5.玻璃破碎扩展条款<br>
            6.锅炉、压力容器扩展条款<br>
            7.错误和遗漏条款<br>
            8.不受控制条款<br>
            9.不使失效条款<br>
          </p>
        </div>
        <div class="btn_list">
          <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy"
            :disabled="disabledAll">去投保</a-button>
        </div>
      </div>
    </a-form-model>
  </div>
</template>

<script>
  import moment from "moment";
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
    data() {
      return {
        allData: {},
        premiumSum: 0, //总保费
        planOffsetDay: 0,
        // 测算要提交的数据
        DQZROptions: [   // 附加盗抢责任
          {
            value: '1',
            name: "是"
          },
          {
            value: '-1',
            name: "否"
          }
        ],
        // 测算要提交的数据
        countData: {
          ZXJJ: "0",//装修及其家具
          JQSB: '0',//机器设备
          CHJE: "0",//存货金额
          DQZR: "-1" //附加盗抢责任
        },
        // 校验规则
        rules: {
          YYXZ: [
            { required: true, message: '请选择营业性质', trigger: 'blur' },
          ],
          YYMJ: [
            { required: true, message: '请填写营业面积', trigger: 'blur' },
          ],
          GZZR: [
            { required: true, message: '请填写公众责任', trigger: 'blur' },
          ],
        },
        //提交data
        data: {},
        planType: "A",
        creator: "1",
        productCode: "",
        plan: "",
        userParams: "",
        //营业性质
        FJXoptions: [
          {
            value: "0",
            name: "否",
          },
          {
            value: "1",
            name: "是",
          }
        ],
        QYZRBoptions: [
          {
            value: "0",
            name: "否",
          },
          {
            value: "50",
            name: "是",
          }
        ],
        CLZXoptions: [
          {
            value: "0",
            name: "否",
          },
          {
            value: "20",
            name: "是",
          }
        ],
        KRCCZRoptions: [
          {
            value: "0",
            name: "否",
          },
          {
            value: "70",
            name: "是",
          }
        ],
        CZRZRoptions: [
          {
            value: "0",
            name: "否",
          },
          {
            value: "50",
            name: "是",
          }
        ]
      };
    },
    computed: {
      // 险种的数组
      riskInfos() {
        let infos = [
          {
            riskCode: "PL0400011", //装修及家具
            amount: this.countData.ZXJJ,
            premiumAmt: 0,
            dutyCode: 'TT040024',
            riskName: `装修及家具`,
            riskAmountDesc: this.countData.ZXJJ
          },
          {
            riskCode: "PL0400011", //机械设备
            amount: this.countData.JQSB,
            premiumAmt: 0,
            dutyCode: 'TT040002',
            riskName: `机械设备`,
            riskAmountDesc: this.countData.JQSB
          },
          {
            riskCode: "PL0400011", //存货
            amount: this.countData.CHJE,
            premiumAmt: 0,
            dutyCode: 'TT040023',
            riskName: `存货`,
            riskAmountDesc: this.countData.CHJE
          },
          {
            riskCode: "PL0400201", //盗抢责任险
            amount: this.countData.DQZR,
            premiumAmt: 0,
            dutyCode: 'PL0400201',
            riskName: `盗抢责任险`,
            riskAmountDesc: this.countData.DQZR
          }
        ];
        return infos;
      },
    },
    methods: {
      moment,
      busOnDataMethod() {
        let data = this.$lodash.cloneDeep(this.$parent.$refs.policyInfo.submitdata);
        console.log(data, "接收到的数据");
        this.$nextTick(() => {
          this.premiumSum = data.salPolicy.totalPremium
          this.countData.DQZR = '-1'
          data.riskInfos.forEach(e => {
            if (e.dutyCode == 'TT040024') {//装修及家具
              this.countData.ZXJJ = e.amount.toString()
            }
            if (e.dutyCode == 'TT040002') {//机械设备
              this.countData.JQSB = e.amount.toString()
            }
            if (e.dutyCode == 'TT040023') {//存货
              this.countData.CHJE = e.amount.toString()
            }
            if (e.dutyCode == 'PL0400201') {//盗抢责任险
              this.countData.DQZR = e.amount.toString() || "0"
            }
          });
        });
      },
      busDatehander() {
        this.changeData()
      },
      // 改变试算的数据
      changeData(value, param) {
        console.log(value, param);
        console.log(this.countData.effectiveDate);
        // if (!value || !param) return;
        this.countData[param] = value;
        this.data = {
          riskInfos: this.riskInfos.filter((item) => item.amount > -1),
          salPolicy: {
            planCode: this.plan,
            creator: this.creator,
            bracket: "12", //保费期限
            productCode: this.productCode, //产品code
          },
          salPolicyExt: {
            isworkheightinvolved: "2",
          },
          salPolicyHolder: {
            addfifty: "2", // 测算类型
            stature: "2", //是否高空（2-否，1-是）
            companytype: this.countData.YYXZ,//营业性质
            area: this.countData.YYMJ,//营业面积
          },
        };
        let arrData = this.$lodash.cloneDeep(this.data);
        console.log(arrData, "传过来的数据");
        this.allData = { ...arrData };
        this.$nextTick(() => {
          this.$parent.$refs.policyInfo.busDataMethod();
        })
      },
      //保费试算
      countPremiumSum() {
        this.changeData()
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$api.calPremiumEmployer(this.allData).then((res) => {
              if (res.data.success) {
                if (res.data.content) {
                  let data = res.data.content
                  this.premiumSum = res.data.content.total;
                  this.riskInfos.forEach(e => {
                    if (e.dutyCode == 'TT040024') {//装修及家具
                       e.premiumAmt = data['TT040024']
                    }
                    if (e.dutyCode == 'TT040002') {//机械设备
                       e.premiumAmt = data['TT040002']
                    }
                    if (e.dutyCode == 'TT040023') {//存货
                       e.premiumAmt = data['TT040023']
                    }
                    if (e.dutyCode == 'PL0400201') {//盗抢责任险
                       e.premiumAmt = data['PL0400201']
                    }
                  })
                }
              } else {
                this.$message.error(res.data.returnMsg + "错误");
              }
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .policy {
    display: none;
  }

  .calTxt_ {
    font-size: 18px !important;
    font-weight: bold !important;
    color: #666666;
  }

  .pre-box {
    margin-top: 15px;
  }

  .risk_ {
    width: 60%;
  }

  .btn_list {
    margin-top: 20px;
    display: flex;

    .calBtn_ {
      margin-right: 30px;
    }
  }

  .flex_ {
    display: flex;
    flex-wrap: wrap;
  }

  .form_item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #333;
    margin-bottom: -10px;

    &.width_50 {
      width: 50%;
    }

    &.width_40 {
      width: 40%;
    }

    &.width_60 {
      width: 60%;
    }

    >label {
      white-space: nowrap;
      margin-right: 10px;
      margin-top: 15px;
    }

    .right_ {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;

      .select_ {
        margin-top: 10px;
      }

      .check_item {
        display: flex;
        align-items: center;
        margin-right: 10px;
        margin-top: 10px;

        &.on {
          label {
            border-color: #fe8f2d;
          }
        }

        label {
          // border: 1px solid #d9d9d9;
          padding: 3px 10px;
          border-radius: 3px;
          margin-right: 5px;
        }

        &.s_input input {
          width: 50px;
        }

        input {
          width: 150px;
          margin-right: 5px;
        }
      }
    }
  }

  .p-header {
    width: 100%;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 0;
  }

  .form_item {
    margin-bottom: -10px;

    .ant-form-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }

  .aftertext {
    position: relative;
  }

  .aftertext::after {
    content: "公众责任累计赔偿限额不能小于50万且不能超过3000万！";
    position: absolute;
    color: #fe8f2d;
    top: 14px;
    right: -300px;
    z-index: 2;
  }

  .tiaokuan_list {
    line-height: 24px;
  }
</style>